import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Chip,
  Modal,
  Checkbox,
  ClickAwayListener,
  Divider,
  FormControlLabel,
  FormGroup,
  Slider,
  CircularProgress,
} from "@mui/material";
import checked from "../../../Assets/Images/Common/checked.svg";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Button from "../../../Subcomponents/Button";
import CustomInput from "../../../Subcomponents/CustomInput";
import DropDown from "../../../Subcomponents/DropDown";
import {
  getFarvisionStatus,
  UpdateFarvisionStatus,
  getAllProjects,
} from "../../../Services/Event";
import LeadStatusChip from "../../../Subcomponents/LeadStatusChip";
import cssClasses from "./HoldPageDetails.module.css";
import HoldModal from "./HoldModule";
import action from "../../../Redux Store/actions";
import SearchBar from "../../../Subcomponents/Search";
import VisibilityOutlined from "@mui/icons-material/VisibilityOutlined";
import IconButton from "@mui/material/IconButton";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import DateComponent from "../../../Subcomponents/DateComponent";
import actions from "../../../Redux Store/actions";
import { findIndex } from "lodash";

const dataGridStyles = {
  "&.MuiDataGrid-root .MuiDataGrid-cell:focus": {
    outline: "none",
  },
  border: "1px solid #EAECF0 !important",
  fontWeight: "400",
  fontSize: "1.4rem",
  lineHeight: "2rem",
  color: "#667085",
  fontFamily: "Inter-Medium",
  borderRadius: "8px",
  '& div[data-colindex="1"]': {
    color: "#101828",
    fontWeight: "500",
  },
  "& .MuiDataGrid-virtualScrollerRenderZone": {
    "& .MuiDataGrid-row": {
      borderBottom: "1px solid #EAECF0",
      background: "#FFFFFF",
      /* Shadow/xl */

      // boxShadow: "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
      borderRadius: "1rem",

      //   "&:nth-of-type(2n+1)": { backgroundColor: "rgba(249, 250, 251, 1)" },
      //   backgroundColor: "#FFFFFF",
    },
    "& .MuiDataGrid-row.Mui-selected:hover": {
      borderBottom: "1px solid #EAECF0",
      backgroundColor: "#FFFFFF",
      // "&:nth-of-type(2n+1)": {
      //   backgroundColor: "rgba(249, 250, 251, 1)",
      // },
    },
  },
  "& .MuiDataGrid-iconSeparator ": {
    display: "none",
  },
  "& .MuiDataGrid-columnHeader:hover": {
    "& .MuiDataGrid-menuIcon": {
      visibility: "hidden",
    },
  },

  "&  .MuiDataGrid-columnHeaders": {
    background: "#F9FAFB",
    /* Gray/200 */
    border: "1px solid #EAECF0",
    /* Shadow/xl */
    // boxShadow:
    //   "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
    // borderRadius: "8px",

    marginBottom: "1rem",
    borderBottom: "6px solid #EAECF0",
  },
  "& .MuiDataGrid-columnSeparator": {
    display: "none",
  },
  "& .MuiDataGrid-checkboxInput": {
    "& svg": {
      width: "2rem",
      height: "2rem",
      background: "#FFFFFF",
    },
  },
  // "& .MuiTablePagination-displayedRows": {
  //   display: "none",
  // },
  "& .MuiDataGrid-footerContainer": {
    "& .MuiTablePagination-displayedRows ": {
      display: "none",
    },
    "& .MuiDataGrid-selectedRowCount": {
      visibility: "hidden ",
    },
  },
  "&  [title='Sort']": {
    //visibility:"hidden",
    display: "none",
    cursor: "none",
  },
  "& [title='Go to previous page']": {
    borderRadius: "0",
    border: "1px solid #EAECF0",
    borderRadius: "0.8rem",
    marginRight: "0.5rem",
  },
  "& [title='Go to next page']": {
    borderRadius: "0",
    border: "1px solid #EAECF0",
    borderRadius: "0.8rem",
    marginRight: "0.5rem",
  },
  "& [title='Go to previous page']:after": {
    content: "'Previous'",
    marginLeft: "1rem",
  },
  "& [title='Go to next page']:before": {
    content: "'Next'",
    marginRight: "1rem",
  },
  "& .MuiDataGrid-columnHeader": {
    padding: "0 4rem",

    "&:focus": {
      outline: "none",
    },
  },
  "&  .MuiDataGrid-row ": {
    maxHeight: "72px !important",
    minHeight: "72px !important",
  },
  "& .MuiDataGrid-cell": {
    padding: "0 4rem",
    minHeight: "72px !important",
    maxHeight: "72px !important",
    "&:focus": {
      outline: "none",
    },
  },
  "& .MuiButtonBase-root": {
    fontSize: "1.6rem",
  },
  "& .MuiDataGrid-cell:focus-within": {
    outline: "none !important",
  },
  "& .MuiDataGrid-cell": {
    padding: "0 2rem",
    minHeight: "72px !important",
    maxHeight: "72px !important",
    "&:focus": {
      outline: "none",
    },
  },
  "& .MuiDataGrid-columnHeader": {
    padding: "0 1rem",

    "&:focus": {
      outline: "none",
    },
  },
};
const HoldPageDetails = () => {
  const dispatch = useDispatch();
  const [holdData, setHoldData] = useState([]);
  console.log("Hold Data in HoldPageDetails:", holdData);
  const [currentPage, setCurrentPage] = useState(0);
  const [openReleaseModal, setOpenReleaseModal] = useState(false);
  const [selectedUnit, setSelectedUnit] = useState(null);
  const [sortValue, setSortValue] = useState("Latest First");
  const [projectFilter, setProjectFilter] = useState("All");
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [unitFilter, setUnitFilter] = useState("All");
  const [searchUnit, setSearchUnit] = useState("");
  let loggedInUser = useSelector((state) => state.Auth.user);
  const [HoldButton, setHoldButton] = useState(true);
  const [openReasonModal, setOpenReasonModal] = useState(false);
  const [selectedReason, setSelectedReason] = useState("");
  const [projects, setProjects] = useState([]);
  const [updateUnitPrice, setUpdateUnitPrice] = useState({
    bsp: "",
    gst: "",
    sdr: "",
    total: "",
  });
  const [listOfDropDown, setListOfDropDown] = useState([
    { label: "None", select: true },
    { label: "Project", select: false },
    { label: "Reason", select: false },
    { label: "Date", select: false },
  ]);
  //Filters
  const [selectDates, setSelectDates] = useState([
    { label: "StartDate", value: "" },
    { label: "EndDate", value: "" },
  ]);
  const [helperText, setHelperText] = useState({
    startDate: "",
    endDate: "",
  });
  const [showProjectDropDown, setShowProjectDropDown] = useState(false);
  const [reasonList, setReasonList] = useState([
    "Change of Design",
    "Management Hold",
    "Leased/Preleased",
    "Amenities",
    "Future Sell",
    "Other",
  ]);
  const [showReasonDropDown, setShowReasonDropDown] = useState(false);
  const [showDateDropDown, setShowDateDropDown] = useState(false);
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [selectedReasons, setSelectedReasons] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [showDropDown, setShowDropDown] = useState(false);

  const [selectedListDropDown, setSelectedListDropDown] = useState([]);
  const [lockedUnitsLoading, setLockedUnitsLoading] = useState(false);

  console.log("Hold Data", holdData);

  useEffect(() => {
    dispatch(actions.activeMenu("hold"));
  }, [dispatch]);

  const projectList = ["All", ...projects.map((p) => p.projectName)];

  const unitList = [
    "All",
    ...new Set(holdData.map((u) => u.unitNo).filter(Boolean)),
  ];
  const filtered = holdData.filter(
    (item) =>
      (projectFilter === "All" ||
        item.projectName?.trim().toLowerCase() ===
        projectFilter?.trim().toLowerCase()) &&
      (searchUnit === "" ||
        item.unitNo?.toLowerCase().includes(searchUnit.toLowerCase())) // Filter by unit number search
  );

  const sorted = [...filtered].sort((a, b) => {
    const dateA = a.lastUpdatedAt ? new Date(a.lastUpdatedAt) : new Date(0);
    const dateB = b.lastUpdatedAt ? new Date(b.lastUpdatedAt) : new Date(0);

    switch (sortValue) {
      case "Name Ascending":
        return a.projectName.localeCompare(b.projectName);

      case "Name Descending":
        return b.projectName.localeCompare(a.projectName);

      case "Oldest First":
        return dateA - dateB;

      case "Latest First":
      default:
        return dateB - dateA; // ✅ NEW ENTRIES ON TOP
    }
  });

  const pageSizeModal = 10;
  const totalPages = Math.ceil(sorted.length / pageSizeModal);

  const handlePrevious = () => {
    if (currentPage > 0) setCurrentPage((prev) => prev - 1);
  };

  const handleNext = () => {
    if (currentPage < totalPages - 1) setCurrentPage((prev) => prev + 1);
  };

  const paginatedData = sorted.slice(
    currentPage * pageSizeModal,
    currentPage * pageSizeModal + pageSizeModal
  );

  const lockedCount = holdData.length;

  const fetchHoldUnits = async () => {
    try {
      setLockedUnitsLoading(true);
      const data = await getFarvisionStatus();
      console.log("Data-------->", data);

      setHoldData(Array.isArray(data) ? data : []);
       setLockedUnitsLoading(false);
    } catch (err) {
      console.error("Error fetching hold units:", err);
       setLockedUnitsLoading(false);
    }
  };
  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const data = await getAllProjects();
        setProjects(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error("Error fetching projects:", err);
      }
    };

    fetchProjects();
  }, []);

  useEffect(() => {
    fetchHoldUnits();
  }, [refreshTrigger]);
  const handleHoldUpdateSuccess = () => {
    setRefreshTrigger((prev) => prev + 1);
  };
  const releaseUnit = async () => {
    if (!selectedUnit) return;

    try {
      await UpdateFarvisionStatus(selectedUnit.unitId, "Available");
      const updatedData = holdData.map((unit) =>
        unit.unitId === selectedUnit.unitId
          ? {
            ...unit,
            inventoryStatusId: {
              ...unit.inventoryStatusId,
              status: "Available",
            },
          }
          : unit
      );
      setHoldData(updatedData);
      setOpenReleaseModal(false);
    } catch (err) {
      console.error("Failed to release unit:", err);
    }
  };
  const clearFilters = () => {
    setProjectFilter("All"); // Reset project filter
    setUnitFilter("All"); // Reset unit filter
    setSearchUnit(""); // Clear search input
    setSelectedProjects([]); // Clear selected projects
    setSelectedReasons([]); // Clear selected reasons
    setSelectedDate(null); // Clear selected date
    setSelectDates([
      { label: "StartDate", value: "" },
      { label: "EndDate", value: "" },
    ]); // Reset start and end date
    setHelperText({ startDate: "", endDate: "" }); // Reset helper text
    setSelectedListDropDown([]); // Reset dropdown selections
    setShowDropDown(false); // Close any dropdowns

    // Reload data with no filters applied
    fetchHoldUnits(); // This can be your function to fetch the original, unfiltered data
  };

  const applyFilters = () => {
    // Apply logic here based on selected filters
    const filteredData = holdData.filter((item) => {
      console.log("item", item);
      // Project Filter Logic
      const isProjectMatch =
        selectedProjects.length === 0 ||
        selectedProjects.includes(item.projectName);

      // Unit Filter Logic
      const isUnitMatch =
        unitFilter === "All" || item.unitNo.includes(unitFilter);

      // Reason Filter Logic
      const isReasonMatch =
        selectedReasons.length === 0 ||
        selectedReasons.includes(item.holdReason);

      // Date Filter Logic
      const isDateMatch =
        selectDates[0].value === "" ||
        selectDates[1].value === "" || // If no start date or end date is selected, skip date filtering
        (item.lastUpdatedAt &&
          new Date(item.lastUpdatedAt) >=
          new Date(selectDates[0].value).setHours(0, 0, 0, 0) && // lastUpdatedAt >= Start Date (midnight time)
          new Date(item.lastUpdatedAt) <=
          new Date(selectDates[1].value).setHours(23, 59, 59, 999)); // lastUpdatedAt <= End Date (before midnight)

      console.log("selectDates[0].value", selectDates[0].value);
      console.log("selectDates[1].value", selectDates[1].value);
      console.log("item.lastUpdatedAt", item.lastUpdatedAt);
      // Combine all filter logic to determine if the row should be displayed
      return isProjectMatch && isUnitMatch && isReasonMatch && isDateMatch;
    });

    // Update the displayed data with the filtered data
    setHoldData(filteredData);
    setShowDropDown(false);
  };

  return (
    <>
      {loggedInUser?.roleId?.accessibleTabs?.Hold?.["Hold"]?.["Release"]
        ?.isAccessible && (
          <Box width={"fit-content"} margin={"0 2rem"}>
            <Button
              style={{
                fontSize: "1.4rem",
                lineHeight: "2rem",
                color: "#FFF",
                backgroundColor: "#1570EF",
                borderRadius: "0.8rem",
              }}
              disable={HoldButton}
              padding={"0.8rem 3.7rem"}
              btnName={"Upload CSV"}
            />
          </Box>
        )}
      <Box p={3}>
        {/* Title */}
        {/* <div className={cssClasses.wrapperHeader}>
                      <div className={cssClasses.headerTitle}>ReservedUnits</div>
                 </div> */}

        <Box
          display="flex"
          flexDirection={{ xs: "column", md: "row" }}
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <div className={cssClasses.content}>
            <Box fontSize="1.4rem">{lockedCount} Reserved Units</Box>
          </div>
          {/* Filters */}
          <Box
            display="flex"
            flexDirection={{ xs: "column", sm: "row" }}
            gap={2}
            mt={{ xs: 1, md: 0 }}
          >
            {/* <Box>
                            <Box fontWeight={300} mb={0.5} width={"250px"}>Project</Box>
                            <DropDown
                                list={projectList}

                                selectedValue={projectFilter}
                                onChangeSelect={value => { setProjectFilter(value); setCurrentPage(0); }}
                                style={{ selectedColor: "#175CD3", background: "#E8F0FE" }}
                            />
                        </Box> */}
             {/* <div className={cssClasses.wrapperFilter}> */}
            
            <div style={{ display: 'flex', gap: '10px', minWidth: '800px', justifyContent: 'flex-end' }}>
              
              <div className={cssClasses.wrapperDropDown} style={{ maxWidth: "300px" }}>
                <div>
              <div className={cssClasses.filterTitle}>Filter by</div>
                <div
                  className={cssClasses.wrapperCustomiseDropDown}
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowDropDown(!showDropDown);
                  }}
                >
                  <div className={cssClasses.dropDownLabel}>
                    <span className={cssClasses.dropDownLabelValue}>
                      {selectedListDropDown.join()}
                    </span>
                    {selectedListDropDown.length === 0 && (
                      <span className={cssClasses.dropDownLabelValue}>
                        None
                      </span>
                    )}
                  </div>
                  <span>
                    {" "}
                    <KeyboardArrowDownIcon
                      className={cssClasses.dropDownIcon}
                    />
                  </span>
                </div>
                         
                </div>

                {showDropDown && (
                  <ClickAwayListener
                    onClickAway={() => {
                      setShowDropDown(false);
                    }}
                  >
                    <div className={cssClasses.containerCustomiseDropDown}>
                      <div className={cssClasses.wrapperSelectAndCheckbox}>
                        <div className={cssClasses.wrapperEachSelect}>
                          {listOfDropDown.map((each, index) => {
                            return (
                              <div
                                className={
                                  each.select
                                    ? cssClasses.selectedVal
                                    : cssClasses.containerEachSelect
                                }
                              >
                                <div
                                  className={cssClasses.eachSelect}
                                  onClick={() => {
                                    setListOfDropDown((pre) =>
                                      pre.map((m) => ({
                                        ...m,
                                        select: m.label === each.label,
                                      }))
                                    );

                                    // Reset all
                                    setShowProjectDropDown(false);
                                    setShowReasonDropDown(false);
                                    setShowDateDropDown(false);

                                    if (each.label === "None") {
                                      setSelectedProjects([]);
                                      setSelectedReasons([]);
                                      setSelectedDate(null);
                                      setSelectedListDropDown([]);
                                    }

                                    if (each.label === "Project") {
                                      setShowProjectDropDown(true);
                                    }

                                    if (each.label === "Reason") {
                                      setShowReasonDropDown(true);
                                    }

                                    if (each.label === "Date") {
                                      setShowDateDropDown(true);
                                    }
                                  }}
                                >
                                  {each.label}
                                </div>
                                {each.select && (
                                  <img
                                    src={checked}
                                    alt={"checked"}
                                    style={{ marginRight: "2rem" }}
                                  />
                                )}
                              </div>
                            );
                          })}
                        </div>
                        <div className={cssClasses.wrapperCheckbox}>
                          {showProjectDropDown &&
                            projects.map((each, index) => (
                              <FormGroup key={each.projectId}>
                                <FormControlLabel
                                  control={<Checkbox />}
                                 label={
                                      <span style={{ fontSize: "13px"}}>
                                        {each.projectName}
                                      </span>}
                                  checked={selectedProjects.includes(
                                    each.projectName
                                  )}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      // Add project to selectedProjects
                                      setSelectedProjects((prev) => [
                                        ...prev,
                                        each.projectName,
                                      ]);

                                      // Mark "Project" as selected in dropdown
                                      let indexOfMainList = findIndex(
                                        listOfDropDown,
                                        ({ label }) => label === "Project"
                                      );
                                      setListOfDropDown((pre) => {
                                        pre[indexOfMainList].select = true;
                                        return [...pre];
                                      });

                                      // Add "Project" to selectedListDropDown if not already selected
                                      if (
                                        !selectedListDropDown.includes(
                                          "Project"
                                        )
                                      ) {
                                        selectedListDropDown.push("Project");
                                      }
                                    } else {
                                      // Remove project from selectedProjects
                                      setSelectedProjects((prev) =>
                                        prev.filter(
                                          (p) => p !== each.projectName
                                        )
                                      );

                                      // Unselect "Project" in dropdown
                                      let indexOfMainList = findIndex(
                                        listOfDropDown,
                                        ({ label }) => label === "Project"
                                      );
                                      setListOfDropDown((pre) => {
                                        pre[indexOfMainList].select = false;
                                        return [...pre];
                                      });

                                      // Remove "Project" from selectedListDropDown
                                      setSelectedListDropDown((prev) =>
                                        prev.filter(
                                          (value) => value !== "Project"
                                        )
                                      );
                                    }
                                  }}
                                />
                              </FormGroup>
                            ))}

                          {showReasonDropDown &&
                            reasonList.map((reason, index) => (
                              <FormGroup key={reason}>
                                <FormControlLabel
                                  control={<Checkbox />}
                                  label={ <span style={{ fontSize: "13px"}}>
                                          {reason}
                                        </span>}
                                  checked={selectedReasons.includes(reason)}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      // Add reason to selectedReasons
                                      setSelectedReasons((prev) => [
                                        ...prev,
                                        reason,
                                      ]);

                                      // Mark "Reason" as selected in dropdown
                                      let indexOfMainList = findIndex(
                                        listOfDropDown,
                                        ({ label }) => label === "Reason"
                                      );
                                      setListOfDropDown((pre) => {
                                        pre[indexOfMainList].select = true;
                                        return [...pre];
                                      });

                                      // Add "Reason" to selectedListDropDown if not already selected
                                      if (
                                        !selectedListDropDown.includes("Reason")
                                      ) {
                                        selectedListDropDown.push("Reason");
                                      }
                                    } else {
                                      // Remove reason from selectedReasons
                                      setSelectedReasons((prev) =>
                                        prev.filter((r) => r !== reason)
                                      );

                                      // Unselect "Reason" in dropdown
                                      let indexOfMainList = findIndex(
                                        listOfDropDown,
                                        ({ label }) => label === "Reason"
                                      );
                                      setListOfDropDown((pre) => {
                                        pre[indexOfMainList].select = false;
                                        return [...pre];
                                      });

                                      // Remove "Reason" from selectedListDropDown
                                      setSelectedListDropDown((prev) =>
                                        prev.filter(
                                          (value) => value !== "Reason"
                                        )
                                      );
                                    }
                                  }}
                                />
                              </FormGroup>
                            ))}

                          {showDateDropDown && (
                            <div>
                              <div className={cssClasses.dateDivider}>
                                <div className={cssClasses.label}>
                                  Start Date
                                </div>
                                <DateComponent
                                  value={selectDates[0].value}
                                  minDate={"1 Jan"}
                                  onChangeDate={(value) => {
                                    setSelectedDate("notNull");
                                    setSelectDates((pre) => {
                                      pre[0].value = value;
                                      return { ...pre };
                                    });
                                    setHelperText((pre) => {
                                      pre.endDate = "";
                                      return { ...pre };
                                    });
                                  }}
                                  helperText={helperText.startDate}
                                ></DateComponent>
                              </div>
                              <div>
                                <div className={cssClasses.label}>End Date</div>
                                <DateComponent
                                  value={selectDates[1].value}
                                  minDate={"1 Jan"}
                                  onChangeDate={(value) => {
                                    setSelectedDate("notNull");
                                    if (selectDates[0].value === "") {
                                      setHelperText((pre) => {
                                        pre.endDate =
                                          "Please select start date first";
                                        return { ...pre };
                                      });
                                    } else {
                                      if (selectDates[0].value > value) {
                                        setHelperText((pre) => {
                                          pre.endDate =
                                            "Select End Date Greater than start Date";
                                          return { ...pre };
                                        });
                                      } else {
                                        setSelectDates((pre) => {
                                          pre[1].value = value;
                                          return { ...pre };
                                        });
                                        setHelperText((pre) => {
                                          pre.endDate = "";
                                          return { ...pre };
                                        });
                                        let indexOfMainList = findIndex(
                                          listOfDropDown,
                                          ({ label }) => label === "Date"
                                        );
                                        setListOfDropDown((pre) => {
                                          pre[indexOfMainList].select = true;
                                          return [...pre];
                                        });
                                        if (
                                          selectedListDropDown.find(
                                            (value) => value === "Date"
                                          ) === undefined
                                        ) {
                                          selectedListDropDown.push("Date");
                                        }
                                      }
                                    }
                                  }}
                                  helperText={helperText.endDate}
                                ></DateComponent>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className={cssClasses.wrapperDropDownButtons}>
                        <div>
                          <Button
                            style={{
                              color: "#344054",
                              backgroundColor: "#ffffff",
                              fontSize: "1.4rem",
                              lineHeight: "2rem",
                            }}
                            padding={"0.8rem"}
                            btnName={"Clear"}
                            clicked={clearFilters}
                          />
                        </div>
                        <div>
                          <Button
                            style={{
                              color: "#ffffff",
                              backgroundColor: "#1570EF",
                              fontSize: "1.4rem",
                              lineHeight: "2rem",
                            }}
                            padding={"0.8rem"}
                            btnName={"Apply"}
                            clicked={applyFilters}
                          />
                        </div>
                      </div>
                    </div>
                  </ClickAwayListener>
                )}
              </div>
              <div>

                <div>
  <div className={cssClasses.filterTitle}>Search</div>
  <div fontWeight={300} mb={0.5} width={"350px"} mt={3.7}></div>
              <SearchBar
                placeholder={"Search By Unit Number"}
                search={(e) => {
                  setSearchUnit(e.target.value); // Update search term
                  setCurrentPage(0); // Reset to first page when search changes
                }}
              />
            </div>

                </div>

            
            </div>
            {/* 
            <Box>
              <Box fontWeight={300} mb={0.5} width={"250px"} mt={3.7}></Box>
              <SearchBar
                placeholder={"Search By Unit Number"}
                search={(e) => {
                  setSearchUnit(e.target.value); // Update search term
                  setCurrentPage(0); // Reset to first page when search changes
                }}
              />
            </Box> */}
          </Box>
        </Box>

        <Divider sx={{ mb: 2 }} />
{
  lockedUnitsLoading ? (
    <Box display="flex" justifyContent="center" alignItems="center" style={{ height: "60vh" }}>
      <CircularProgress />
    </Box>
  ) : paginatedData.length === 0 ? (
    <div style={{ textAlign: "center", padding: "20px", fontSize: "16px", color: "gray" }}>
      No Reserved Units Found
    </div>
  ) : (
        <TableContainer
          sx={{
            height: {
              xs: "60vh",
              sm: "65vh",
              md: "55vh",
              lg: "60vh",
            },
            overflowY: "auto",
            borderRadius: 2,
            border: "1px solid #e5e7eb",
            mt: 3,
            "& th, & td": {
              padding: "8px 14px",
              lineHeight: "1.2",
              whiteSpace: "nowrap",
            },
          }}
        >
          <Table>
            <TableHead>
              <TableRow
                sx={{
                  height: 60,
                }}
              >
                {[
                  "Project Name",
                  "Wing",
                  "Unit Type",
                  "Unit No",
                  "Status",
                  "Reason",
                  "Status Reason",
                  "Created",
                  "Release",
                ].map((header) => (
                  <TableCell
                    key={header}
                    sx={{
                      fontFamily:
                        '"Inter-Medium", "Inter-Regular", "Roboto-Regular", "Arial", "sans-serif"',
                      backgroundColor: "#f5f5f5",
                      fontWeight: 500, // This corresponds to --font-weight-medium
                      position: "sticky",
                      top: 0,
                      color: "gray",
                      fontSize: "1.6rem", // This corresponds to --font-size-md
                    }}
                  >
                    {header}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {paginatedData.map((row) => (
                <TableRow
                  key={row.unitId}
                  sx={{
                    height: 60,
                  }}
                >
                  <TableCell
                    style={{
                      fontSize: "1.5rem",
                      color: "black",
                      fontWeight: "200",
                      fontFamily: "Roboto-Regular",
                    }}
                  >
                    {row.projectName}
                  </TableCell>
                  <TableCell
                    style={{
                      fontSize: "1.5rem",
                      color: "gray",
                      fontFamily: "Roboto-Regular",
                    }}
                  >
                    {row.wingName}
                  </TableCell>
                  <TableCell
                    style={{
                      fontSize: "1.5rem",
                      color: "gray",
                      fontFamily: "Roboto-Regular",
                    }}
                  >
                    {row.unitType || "-"}
                  </TableCell>
                  <TableCell
                    style={{
                      fontSize: "1.5rem",
                      color: "gray",
                      fontFamily: "Roboto-Regular",
                    }}
                  >
                    {row.unitNo || "-"}
                  </TableCell>

                  {/* Chip with Dot */}
                  <TableCell>
                    <LeadStatusChip
                      label={
                        <Box display="flex" alignItems="center" gap={1}>
                          <Box
                            sx={{
                              width: 8,
                              height: 8,
                              borderRadius: "50%",
                              bgcolor:
                                row.inventoryStatusId.status?.toLowerCase() ===
                                  "reserved"
                                  ? "#C47A00"
                                  : "#047857",
                            }}
                          />
                          {row.inventoryStatusId.status
                            ? row.inventoryStatusId.status
                              .charAt(0)
                              .toUpperCase() +
                            row.inventoryStatusId.status
                              .slice(1)
                              .toLowerCase()
                            : "-"}
                        </Box>
                      }
                      style={{
                        backgroundColor:
                          row.inventoryStatusId.status?.toLowerCase() ===
                            "reserved"
                            ? "#FFF1C2"
                            : "#D1FAE5",
                        color:
                          row.inventoryStatusId.status?.toLowerCase() ===
                            "reserved"
                            ? "#523B05"
                            : "#064E3B",
                        fontSize: "0.75rem",
                        height: "24px",
                        minWidth: "90px",
                        borderRadius: "8px",
                      }}
                    />
                  </TableCell>

                  <TableCell style={{ fontSize: "1.6rem", color: "gray" }}>
                    {row.holdReason || "-"}
                  </TableCell>
                  <TableCell
                    align="center"
                    style={{ fontSize: "1.6rem", color: "gray" }}
                  >
                    {row.unitStatusChangeReason ? (



                      <VisibilityOutlined
                        onClick={() => {
                          setSelectedReason(row.unitStatusChangeReason);
                          setOpenReasonModal(true);
                        }} sx={{ fontSize: "2.6rem" }} />

                    ) : (
                      "-"
                    )}
                  </TableCell>

                  <TableCell
                    style={{
                      fontSize: "1.6rem",
                      color: "gray",
                      marginLeft: "1rem",
                    }}
                  >
                    {new Date(row.lastUpdatedAt).toLocaleDateString("en-GB")}
                  </TableCell>

                  {/* <TableCell style={{ fontSize: "1.3rem", color: "gray" }}>{row.lastUpdatedAt ? new Date(row.lastUpdatedAt).toLocaleDateString() : "-"}</TableCell> */}

                  <TableCell>
                    <Button
                      btnName="Release"
                      style={{
                        backgroundColor: "#1570EF",
                        color: "#fff",
                        borderRadius: "6px", // More rounded corners
                        padding: "6px 12px", // Decreased padding to reduce button size
                        fontSize: "14px", // Decreased font size
                      }}
                      clicked={() => {
                        setSelectedUnit(row);
                        setUpdateUnitPrice({
                          bsp: row.BSP || row.agreementValue || "",
                          gst: row.GST || "",
                          sdr: row.SDR || "",
                          total: row.totalCost || "",
                        });
                        setOpenReleaseModal(true);
                      }}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
  )
}


        <Box display="flex" justifyContent="end" alignItems="center" mt={2}>
          <Box display="flex" justifyContent="end" gap={2}>
            <Button
              btnName="Previous"
              disabled={currentPage === 0}
              clicked={handlePrevious}
              style={{
                backgroundColor: currentPage === 0 ? "#ccc" : "#1570EF",
                color: "#fff",
              }}
            />
            <Button
              btnName="Next"
              disabled={currentPage >= totalPages - 1}
              clicked={handleNext}
              style={{
                backgroundColor:
                  currentPage >= totalPages - 1 ? "#ccc" : "#1570EF",
                color: "#fff",
              }}
            />
          </Box>
        </Box>
        {openReleaseModal && (
          <HoldModal
            open={openReleaseModal}
            onClose={() => setOpenReleaseModal(false)}
            unitData={selectedUnit}
            updatePrice={updateUnitPrice}
            returnRes={handleHoldUpdateSuccess}
          />
        )}

        {/* <Modal open={openReleaseModal} onClose={() => setOpenReleaseModal(false)}>
                    <Box sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        bgcolor: "white",
                        borderRadius: 2,
                        width: { xs: "92%", sm: 560 },
                        maxHeight: "90vh",
                        overflowY: "auto",
                        p: 3,
                    }}>
                        <Box sx={{ position: "absolute", top: 8, right: 12, cursor: "pointer" }} onClick={() => setOpenReleaseModal(false)}>✕</Box>
                        <h3>ReservedUnit</h3>
                        <Box mb={1}><b>{selectedUnit?.wingName} - {selectedUnit?.unitNo} | {selectedUnit?.projectName}</b></Box>

                        <Box display="flex" flexDirection={{ xs: "column", sm: "row" }} gap={5} mb={2}>
                            <span><b>Carpet Area(Sq.ft): </b>{selectedUnit?.chargeableArea ? (Number(selectedUnit.chargeableArea) * 10.764).toFixed(2) : "-"}</span>
                            <span><b>Saleable Area(Sq.ft): </b>{selectedUnit?.saleableArea ? (Number(selectedUnit.saleableArea) * 10.764).toFixed(2) : "-"}</span>
                        </Box>

                        <Box display="grid" gridTemplateColumns={{ xs: "1fr", sm: "1fr 1fr" }} gap={2}>
                            <CustomInput value={updateUnitPrice.bsp} label="Agreement Value" inputType="number" disabled />
                            <CustomInput value={updateUnitPrice.gst} label="GST" inputType="number" disabled />
                            <CustomInput value={updateUnitPrice.sdr} label="SDR" inputType="number" disabled />
                            <CustomInput value={updateUnitPrice.total} label="Total Cost" inputType="number" disabled />
                        </Box>

                        <Box display="flex" justifyContent="flex-end" gap={2} mt={3}>
                            <Button btnName="Cancel" clicked={() => setOpenReleaseModal(false)} />
                            <Button btnName="Update" clicked={releaseUnit} style={{ backgroundColor: "#1570EF", color: "#fff" }} />
                        </Box>
                    </Box>
                </Modal> */}
        <Dialog
          open={openReasonModal}
          onClose={() => {
            setOpenReasonModal(false);
            setSelectedReason("");
          }}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle style={{ fontSize: "1.8rem", fontWeight: 600 }}>
            Status Change Reason
          </DialogTitle>

          <DialogContent>
            <Typography style={{ fontSize: "1.5rem", color: "#374151" }}>
              {selectedReason || "-"}
            </Typography>
          </DialogContent>
          <DialogActions
            sx={{
              justifyContent: "flex-end",
              padding: "1.6rem 2.4rem",
            }}
          >
            <div style={{ width: "fit-content" }}>
              <Button
                btnName="Close"
                clicked={() => {
                  setOpenReasonModal(false);
                  setSelectedReason("");
                }}
                style={{
                  backgroundColor: "#155EEF",
                  color: "#fff",
                  fontSize: "1.4rem",
                  width: "auto",
                  minWidth: "unset",
                }}
              />
            </div>
          </DialogActions>
        </Dialog>
      </Box>
    </>
  );
};

export default HoldPageDetails;